fbm.add("commands/ealogin", ["util/io", "util/pause", "util/screens", "commands/connect", "commands/mint", "commands/pwlogin"], function (uio, upause, cscreens, cconnect, cmint, cpwlogin) {

    let {
        parse,
        type,
        pause,
        eamint,
        pwlogin,
        clear,
        clearKey,
        getScreen,
        waitForKey,
        el,
        addImage,
        link,
        off
    } = {
        ...uio,
        ...upause,
        ...cscreens,
        ...cconnect,
        ...cmint,
        ...cpwlogin
    }


    const apeIn = "/static/images/fba/mint/apein_gs.png";

    async function login() {
        return new Promise(async (resolve, err) => {
            await type(["> APPLYING SECURITY POLICY                    --FAIL--"], {
                lineWait: 250,
                finalWait: 500
            });

            await type(["   ! SECURITY policy is corrupted", "   ! Please contact your system apeministrator for assistance", "   ! Booting into new-user mode"], {lineWait: 900});

            await clearKey("Press any key to continue...");

            let mainScreen = document.querySelector(".terminal");

            let {screen, image} = addImage("ealogin", apeIn);
            let piScreen = getScreen('piscreen');
            piScreen.style.zIndex = 1000;
            let resolved = false;
            let wc = link("javascript:", {
                pre: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
                text: "π",
                classes: 'pi',
                click: (e) => {
                    if (e.ctrlKey && e.shiftKey) {
                        resolved = true;
                        screen.remove();
                        piScreen.remove();
                        resolve(pwlogin(true));
                    }
                }
            });

            await type([wc], {processChars: false}, piScreen);

            let keyPress = await waitForKey([], true);
            if (resolved) {
                return;
            }
            resolved = true;
            screen.remove();
            piScreen.remove();

            if (keyPress === 'n') {
                resolve(off());
                return;
            }

            await parse("connect");
            resolve(eamint());
        });
    }

    return {
        default: login,
        ealogin: login,
    }
});
